/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AuthedRouteImport } from "./routes/_authed";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as WelcomeRouteImport } from "./routes/welcome";
import { Route as AuthedEinstellungenRouteImport } from "./routes/_authed.einstellungen";
import { Route as AuthedAgentsIndexRouteImport } from "./routes/_authed.agents.index";
import { Route as AuthedConversationsConversationIdRouteImport } from "./routes/_authed.conversations.$conversationId";
import { Route as AuthedEinstellungenIndexRouteImport } from "./routes/_authed.einstellungen.index";
import { Route as AuthedEinstellungenKontoRouteImport } from "./routes/_authed.einstellungen.konto";
import { Route as AuthedEinstellungenNutzungRouteImport } from "./routes/_authed.einstellungen.nutzung";
import { Route as AuthedSourcesIdRouteImport } from "./routes/_authed.sources.$id";
import { Route as AuthedConversationsConversationIdZusammenfassungRouteImport } from "./routes/_authed.conversations.$conversationId_.zusammenfassung";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedRoute = AuthedRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const WelcomeRoute = WelcomeRouteImport.update({
  id: "/welcome",
  path: "/welcome",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedEinstellungenRoute = AuthedEinstellungenRouteImport.update({
  id: "/einstellungen",
  path: "/einstellungen",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedAgentsIndexRoute = AuthedAgentsIndexRouteImport.update({
  id: "/agents/",
  path: "/agents/",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedConversationsConversationIdRoute =
  AuthedConversationsConversationIdRouteImport.update({
    id: "/conversations/$conversationId",
    path: "/conversations/$conversationId",
    getParentRoute: () => AuthedRoute,
  } as any);
const AuthedEinstellungenIndexRoute =
  AuthedEinstellungenIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthedEinstellungenRoute,
  } as any);
const AuthedEinstellungenKontoRoute =
  AuthedEinstellungenKontoRouteImport.update({
    id: "/konto",
    path: "/konto",
    getParentRoute: () => AuthedEinstellungenRoute,
  } as any);
const AuthedEinstellungenNutzungRoute =
  AuthedEinstellungenNutzungRouteImport.update({
    id: "/nutzung",
    path: "/nutzung",
    getParentRoute: () => AuthedEinstellungenRoute,
  } as any);
const AuthedSourcesIdRoute = AuthedSourcesIdRouteImport.update({
  id: "/sources/$id",
  path: "/sources/$id",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedConversationsConversationIdZusammenfassungRoute =
  AuthedConversationsConversationIdZusammenfassungRouteImport.update({
    id: "/conversations/$conversationId_/zusammenfassung",
    path: "/conversations/$conversationId/zusammenfassung",
    getParentRoute: () => AuthedRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/login": typeof LoginRoute;
  "/welcome": typeof WelcomeRoute;
  "/einstellungen": typeof AuthedEinstellungenRouteWithChildren;
  "/conversations/$conversationId": typeof AuthedConversationsConversationIdRoute;
  "/einstellungen/konto": typeof AuthedEinstellungenKontoRoute;
  "/einstellungen/nutzung": typeof AuthedEinstellungenNutzungRoute;
  "/sources/$id": typeof AuthedSourcesIdRoute;
  "/agents/": typeof AuthedAgentsIndexRoute;
  "/einstellungen/": typeof AuthedEinstellungenIndexRoute;
  "/conversations/$conversationId/zusammenfassung": typeof AuthedConversationsConversationIdZusammenfassungRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/login": typeof LoginRoute;
  "/welcome": typeof WelcomeRoute;
  "/conversations/$conversationId": typeof AuthedConversationsConversationIdRoute;
  "/einstellungen/konto": typeof AuthedEinstellungenKontoRoute;
  "/einstellungen/nutzung": typeof AuthedEinstellungenNutzungRoute;
  "/sources/$id": typeof AuthedSourcesIdRoute;
  "/agents": typeof AuthedAgentsIndexRoute;
  "/einstellungen": typeof AuthedEinstellungenIndexRoute;
  "/conversations/$conversationId/zusammenfassung": typeof AuthedConversationsConversationIdZusammenfassungRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_authed": typeof AuthedRouteWithChildren;
  "/login": typeof LoginRoute;
  "/welcome": typeof WelcomeRoute;
  "/_authed/einstellungen": typeof AuthedEinstellungenRouteWithChildren;
  "/_authed/conversations/$conversationId": typeof AuthedConversationsConversationIdRoute;
  "/_authed/einstellungen/konto": typeof AuthedEinstellungenKontoRoute;
  "/_authed/einstellungen/nutzung": typeof AuthedEinstellungenNutzungRoute;
  "/_authed/sources/$id": typeof AuthedSourcesIdRoute;
  "/_authed/agents/": typeof AuthedAgentsIndexRoute;
  "/_authed/einstellungen/": typeof AuthedEinstellungenIndexRoute;
  "/_authed/conversations/$conversationId_/zusammenfassung": typeof AuthedConversationsConversationIdZusammenfassungRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/login"
    | "/welcome"
    | "/einstellungen"
    | "/conversations/$conversationId"
    | "/einstellungen/konto"
    | "/einstellungen/nutzung"
    | "/sources/$id"
    | "/agents/"
    | "/einstellungen/"
    | "/conversations/$conversationId/zusammenfassung";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/login"
    | "/welcome"
    | "/conversations/$conversationId"
    | "/einstellungen/konto"
    | "/einstellungen/nutzung"
    | "/sources/$id"
    | "/agents"
    | "/einstellungen"
    | "/conversations/$conversationId/zusammenfassung";
  id:
    | "__root__"
    | "/"
    | "/_authed"
    | "/login"
    | "/welcome"
    | "/_authed/einstellungen"
    | "/_authed/conversations/$conversationId"
    | "/_authed/einstellungen/konto"
    | "/_authed/einstellungen/nutzung"
    | "/_authed/sources/$id"
    | "/_authed/agents/"
    | "/_authed/einstellungen/"
    | "/_authed/conversations/$conversationId_/zusammenfassung";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthedRoute: typeof AuthedRouteWithChildren;
  LoginRoute: typeof LoginRoute;
  WelcomeRoute: typeof WelcomeRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed": {
      id: "/_authed";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/welcome": {
      id: "/welcome";
      path: "/welcome";
      fullPath: "/welcome";
      preLoaderRoute: typeof WelcomeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed/einstellungen": {
      id: "/_authed/einstellungen";
      path: "/einstellungen";
      fullPath: "/einstellungen";
      preLoaderRoute: typeof AuthedEinstellungenRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/agents/": {
      id: "/_authed/agents/";
      path: "/agents";
      fullPath: "/agents/";
      preLoaderRoute: typeof AuthedAgentsIndexRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/conversations/$conversationId": {
      id: "/_authed/conversations/$conversationId";
      path: "/conversations/$conversationId";
      fullPath: "/conversations/$conversationId";
      preLoaderRoute: typeof AuthedConversationsConversationIdRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/einstellungen/": {
      id: "/_authed/einstellungen/";
      path: "/";
      fullPath: "/einstellungen/";
      preLoaderRoute: typeof AuthedEinstellungenIndexRouteImport;
      parentRoute: typeof AuthedEinstellungenRoute;
    };
    "/_authed/einstellungen/konto": {
      id: "/_authed/einstellungen/konto";
      path: "/konto";
      fullPath: "/einstellungen/konto";
      preLoaderRoute: typeof AuthedEinstellungenKontoRouteImport;
      parentRoute: typeof AuthedEinstellungenRoute;
    };
    "/_authed/einstellungen/nutzung": {
      id: "/_authed/einstellungen/nutzung";
      path: "/nutzung";
      fullPath: "/einstellungen/nutzung";
      preLoaderRoute: typeof AuthedEinstellungenNutzungRouteImport;
      parentRoute: typeof AuthedEinstellungenRoute;
    };
    "/_authed/sources/$id": {
      id: "/_authed/sources/$id";
      path: "/sources/$id";
      fullPath: "/sources/$id";
      preLoaderRoute: typeof AuthedSourcesIdRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/conversations/$conversationId_/zusammenfassung": {
      id: "/_authed/conversations/$conversationId_/zusammenfassung";
      path: "/conversations/$conversationId/zusammenfassung";
      fullPath: "/conversations/$conversationId/zusammenfassung";
      preLoaderRoute: typeof AuthedConversationsConversationIdZusammenfassungRouteImport;
      parentRoute: typeof AuthedRoute;
    };
  }
}

interface AuthedEinstellungenRouteChildren {
  AuthedEinstellungenKontoRoute: typeof AuthedEinstellungenKontoRoute;
  AuthedEinstellungenNutzungRoute: typeof AuthedEinstellungenNutzungRoute;
  AuthedEinstellungenIndexRoute: typeof AuthedEinstellungenIndexRoute;
}

const AuthedEinstellungenRouteChildren: AuthedEinstellungenRouteChildren = {
  AuthedEinstellungenKontoRoute: AuthedEinstellungenKontoRoute,
  AuthedEinstellungenNutzungRoute: AuthedEinstellungenNutzungRoute,
  AuthedEinstellungenIndexRoute: AuthedEinstellungenIndexRoute,
};

const AuthedEinstellungenRouteWithChildren =
  AuthedEinstellungenRoute._addFileChildren(AuthedEinstellungenRouteChildren);

interface AuthedRouteChildren {
  AuthedEinstellungenRoute: typeof AuthedEinstellungenRouteWithChildren;
  AuthedConversationsConversationIdRoute: typeof AuthedConversationsConversationIdRoute;
  AuthedSourcesIdRoute: typeof AuthedSourcesIdRoute;
  AuthedAgentsIndexRoute: typeof AuthedAgentsIndexRoute;
  AuthedConversationsConversationIdZusammenfassungRoute: typeof AuthedConversationsConversationIdZusammenfassungRoute;
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedEinstellungenRoute: AuthedEinstellungenRouteWithChildren,
  AuthedConversationsConversationIdRoute:
    AuthedConversationsConversationIdRoute,
  AuthedSourcesIdRoute: AuthedSourcesIdRoute,
  AuthedAgentsIndexRoute: AuthedAgentsIndexRoute,
  AuthedConversationsConversationIdZusammenfassungRoute:
    AuthedConversationsConversationIdZusammenfassungRoute,
};

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  WelcomeRoute: WelcomeRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
